export default __webpack_public_path__ + "static/media/user-colored.238c2e3f.svg";